/** Cart attribute keys owned by the Meta click bridge (refreshed/removed at checkout handoff). */
export const META_CLICK_ATTR_KEYS: readonly string[] = ["_fbclid", "_fbc", "_meta_click_at", "_fbp"];
